import React from "react";
import { Waves } from "lucide-react";
import { cn } from "../../lib/utils";

// The shared Synth Lab page chrome: dreamy background, eyebrow, shimmering
// title, blurb, and an actions slot. `narrow` tightens the column for focused
// screens (the practice player) vs. the roomier home/playground layouts.
const LabShell = ({ eyebrow = "learning to patch", title, blurb, actions, narrow, children }) => (
  <div className="relative min-h-[calc(100vh-4rem)] overflow-hidden bg-dreamy">
    <div
      aria-hidden
      className="pointer-events-none absolute -left-24 -top-24 h-96 w-96 rounded-full bg-primary/15 blur-3xl animate-aurora"
    />
    <div
      aria-hidden
      className="pointer-events-none absolute -bottom-40 -right-24 h-[28rem] w-[28rem] rounded-full bg-[hsl(var(--blue)/0.22)] blur-3xl animate-aurora"
      style={{ animationDelay: "-7s" }}
    />

    <div className={cn("container relative mx-auto px-4 py-10", narrow ? "max-w-2xl" : "max-w-4xl")}>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="inline-flex items-center gap-1.5 text-sm font-medium text-primary">
            <Waves className="h-4 w-4" />
            {eyebrow}
          </p>
          <h1 className="mt-1 text-2xl font-bold tracking-tight sm:text-3xl">
            <span className="text-gold-shimmer">{title}</span>
          </h1>
          {blurb && <p className="mt-2 max-w-xl text-muted-foreground">{blurb}</p>}
        </div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  </div>
);

export default LabShell;
